import { Product, Category } from '../types';

export const categories: Category[] = [
  { id: '1', name: 'Newborn', icon: 'baby' },
  { id: '2', name: 'Nursery', icon: 'bed' },
  { id: '3', name: 'Feeding', icon: 'baby-bottle' },
  { id: '4', name: 'Bath & Skin Care', icon: 'bath' },
  { id: '5', name: 'Health Check', icon: 'heart-pulse' },
  { id: '6', name: 'Kids Wear', icon: 'shirt' },
  { id: '7', name: 'Playtime & Toys', icon: 'puzzle' },
  { id: '8', name: 'Furniture', icon: 'armchair' },
  { id: '9', name: 'Interiors', icon: 'lamp' },
  { id: '10', name: 'Stationery', icon: 'pencil' },
  { id: '11', name: 'Gifts & Packages', icon: 'gift' },
  { id: '12', name: 'Maternity Items', icon: 'heart' },
];

export const products: Product[] = [
  {
    id: '1',
    name: 'Organic Cotton Onesie Set',
    price: 1200,
    image: 'https://images.unsplash.com/photo-1522771930-78848d9293e8',
    category: 'Newborn',
    description: 'Soft and comfortable organic cotton onesie set for newborns',
    featured: true,
    bestSeller: true,
    variations: {
      colors: ['White', 'Pink', 'Blue', 'Yellow'],
      sizes: ['0-3M', '3-6M', '6-9M', '9-12M'],
      ageRanges: ['0-3 months', '3-6 months', '6-9 months', '9-12 months']
    },
    gallery: [
      'https://images.unsplash.com/photo-1522771930-78848d9293e8',
      'https://images.unsplash.com/photo-1555252333-9f8e92e65df9',
      'https://images.unsplash.com/photo-1576566588028-4147f3842f27',
      'https://images.unsplash.com/photo-1519689680058-324335c77eba'
    ]
  },
  {
    id: '2',
    name: 'Educational Wooden Blocks',
    price: 2500,
    image: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4',
    category: 'Playtime & Toys',
    description: 'Educational wooden building blocks set',
    featured: true,
    mostViewed: true,
    variations: {
      ageRanges: ['1-2 years', '2-3 years', '3-4 years', '4+ years']
    },
    gallery: [
      'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4',
      'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1',
      'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1',
      'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1'
    ]
  },
  {
    id: '3',
    name: 'Premium Baby Care Kit',
    price: 3500,
    image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b',
    category: 'Bath & Skin Care',
    description: 'Complete premium baby care essentials set',
    newArrival: true,
    variations: {
      colors: ['Pink', 'Blue', 'Green']
    },
    gallery: [
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b',
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b',
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b'
    ]
  },
  {
    id: '4',
    name: 'Convertible Baby Crib',
    price: 15000,
    image: 'https://images.unsplash.com/photo-1586105449897-20b5efeb3233',
    category: 'Furniture',
    description: '3-in-1 convertible baby crib with mattress',
    featured: true,
    mostViewed: true,
    variations: {
      colors: ['White', 'Natural Wood', 'Gray', 'Dark Brown'],
      sizes: ['Standard', 'Mini']
    },
    gallery: [
      'https://images.unsplash.com/photo-1586105449897-20b5efeb3233',
      'https://images.unsplash.com/photo-1586105449897-20b5efeb3233',
      'https://images.unsplash.com/photo-1586105449897-20b5efeb3233'
    ]
  },
  {
    id: '5',
    name: 'Baby Feeding Set',
    price: 1800,
    image: 'https://images.unsplash.com/photo-1584114326229-8907e3a4533c',
    category: 'Feeding',
    description: 'Complete feeding set with bottles and accessories',
    bestSeller: true,
    variations: {
      colors: ['Pink', 'Blue', 'Green', 'Yellow'],
      ageRanges: ['0-6 months', '6-12 months', '12+ months']
    },
    gallery: [
      'https://images.unsplash.com/photo-1584114326229-8907e3a4533c',
      'https://images.unsplash.com/photo-1584114326229-8907e3a4533c',
      'https://images.unsplash.com/photo-1584114326229-8907e3a4533c'
    ]
  },
  {
    id: '6',
    name: 'Baby Monitor',
    price: 4500,
    image: 'https://images.unsplash.com/photo-1595131838595-3154b9f4450b',
    category: 'Health Check',
    description: 'Digital baby monitor with night vision',
    newArrival: true,
    mostViewed: true,
    variations: {
      colors: ['White', 'Black']
    },
    gallery: [
      'https://images.unsplash.com/photo-1595131838595-3154b9f4450b',
      'https://images.unsplash.com/photo-1595131838595-3154b9f4450b',
      'https://images.unsplash.com/photo-1595131838595-3154b9f4450b'
    ]
  },
  {
    id: '7',
    name: 'Nursery Wall Decor Set',
    price: 2800,
    image: 'https://images.unsplash.com/photo-1586105449897-20b5efeb3233',
    category: 'Interiors',
    description: 'Beautiful nursery wall decoration set',
    featured: true,
    variations: {
      colors: ['Pink/Gold', 'Blue/Silver', 'Rainbow', 'Neutral']
    },
    gallery: [
      'https://images.unsplash.com/photo-1586105449897-20b5efeb3233',
      'https://images.unsplash.com/photo-1586105449897-20b5efeb3233',
      'https://images.unsplash.com/photo-1586105449897-20b5efeb3233'
    ]
  },
  {
    id: '8',
    name: 'Baby Milestone Cards',
    price: 800,
    image: 'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1',
    category: 'Stationery',
    description: 'Cute milestone cards for baby photos',
    mostViewed: true,
    variations: {
      colors: ['Pink', 'Blue', 'Gender Neutral']
    },
    gallery: [
      'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1',
      'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1',
      'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1'
    ]
  },
  {
    id: '9',
    name: 'Soft Play Mat',
    price: 3200,
    image: 'https://images.unsplash.com/photo-1576086135878-bd7e7d326b37',
    category: 'Playtime & Toys',
    description: 'Large, padded play mat for babies',
    newArrival: true,
    variations: {
      colors: ['Multicolor', 'Pastel', 'Neutral'],
      sizes: ['Small (1x1m)', 'Medium (1.5x1.5m)', 'Large (2x2m)']
    },
    gallery: [
      'https://images.unsplash.com/photo-1576086135878-bd7e7d326b37',
      'https://images.unsplash.com/photo-1576086135878-bd7e7d326b37',
      'https://images.unsplash.com/photo-1576086135878-bd7e7d326b37'
    ]
  },
  {
    id: '10',
    name: 'Baby Bath Tub',
    price: 2100,
    image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b',
    category: 'Bath & Skin Care',
    description: 'Safe and comfortable baby bath tub',
    bestSeller: true,
    variations: {
      colors: ['Blue', 'Pink', 'White'],
      ageRanges: ['0-6 months', '6-24 months']
    },
    gallery: [
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b',
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b',
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b'
    ]
  },
  {
    id: '11',
    name: 'Diaper Bag Set',
    price: 4200,
    image: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348',
    category: 'Newborn',
    description: 'Stylish and practical diaper bag with accessories',
    newArrival: true,
    variations: {
      colors: ['Black', 'Navy', 'Gray', 'Pink']
    },
    gallery: [
      'https://images.unsplash.com/photo-1596462502278-27bfdc403348',
      'https://images.unsplash.com/photo-1596462502278-27bfdc403348',
      'https://images.unsplash.com/photo-1596462502278-27bfdc403348'
    ]
  },
  {
    id: '12',
    name: 'Baby Carrier',
    price: 3800,
    image: 'https://images.unsplash.com/photo-1571210862729-78a52d3779a2',
    category: 'Newborn',
    description: 'Ergonomic baby carrier for comfortable carrying',
    bestSeller: true,
    variations: {
      colors: ['Black', 'Gray', 'Navy', 'Burgundy'],
      ageRanges: ['0-4 months', '4-24 months', '24+ months']
    },
    gallery: [
      'https://images.unsplash.com/photo-1571210862729-78a52d3779a2',
      'https://images.unsplash.com/photo-1571210862729-78a52d3779a2',
      'https://images.unsplash.com/photo-1571210862729-78a52d3779a2'
    ]
  }
];